module.exports = __webpack_public_path__ + "static/FalkenapothekeBeratung-ee1db6fb921b4712c96258ff8915f47b.jpg";